module.exports = __webpack_public_path__ + "static/media/01.fc3e7efb.webp";